var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import navigationCss from './navigation.css?type=css';
let NavigationComponent = class NavigationComponent extends LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return html `
      <style>
        ${navigationCss}
      </style>
      
      <div class="host">
        <nav class="as-navigation">
          <ul class="list-unstyled as-navigation__list">
            <li class="as-navigation__list-item">
              <a class="as-navigation__link" href="/artists/">artists</a>
            </li>

            <li class="as-navigation__list-item">
              <a class="as-navigation__link" href="/albums/">albums</a>
            </li>

            <li class="as-navigation__list-item">
              <a class="as-navigation__link" href="/events/">events</a>
            </li>

            <li class="as-navigation__list-item">
              <a class="as-navigation__link" href="/contact/">contact</a>
            </li>
          </ul>
        </nav>
      </div>
    `;
    }
};
NavigationComponent = __decorate([
    customElement('app-navigation')
], NavigationComponent);
export { NavigationComponent };
//# sourceMappingURL=module.js.map